/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-31 14:10:01
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-15 15:12:34
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/index.ts
 */
export { default as SalesChannelProductsLinkProduct } from './SalesChannelProductsLinkProduct';
export { default as SalesChannelProductCustomization } from './SalesChannelProductCustomization';
export { default as SalesChannelProductContent } from './SalesChannelProductContent';
export { default as SalesChannelProductAlias } from './SalesChannelProductAlias/ListPage';
export { default as SalesChannelProductAliasEdit } from './SalesChannelProductAlias/EditPage';

import { randomNumber } from 'src/tools/helper';
import { EnumLinkType } from '@/src/types/common/linkType';

export const contentCarouselGenerator = (draggableId) => {
  return {
    draggableId,
    data: {
      draggableId: randomNumber(),
      linkModule: {
        linkImage: null,
        linkType: EnumLinkType.Product,
      },
      coverImage: false,
      visible: true,
    },
  };
};
